import React from 'react';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';

import { LayoutDynamicZone } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { LayoutCardType, LayoutCard } from 'src/modules/layout';
import { useIntl } from 'react-intl';
import { Row } from 'antd';
import { rowInformativeGridProps } from 'src/utils/grid';
import { LayoutDynamicZoneComponentTypes } from 'src/modules/layout/components/dynamicZone/LayoutDynamicZone';
import Image from 'next/image';
import { PagesStore, PageEntity, PageKeys } from 'src/modules/pages';
import { Media } from 'react-breakpoints';
import { breakpoints } from 'src/utils/breakpoints';
import { useLocale } from 'src/modules/locale';
import styles from './PagesPcon.module.scss';

interface PagesPconProps extends PagesStore {
  page?: PageEntity;
}

const PagesPcon: React.FunctionComponent<PagesPconProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/pcon/head/page_title' }),
    description: intl.formatMessage({ id: 'page/pcon/head/meta_description' }),

    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals',
        }),
        as: '/professionals',
        href: '/professionals',
      },
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals/pcon',
        }),
        as: '/professionals/pcon',
        href: '/professionals/pcon',
        capitalizeLabel: false,
      },
    ],
  };

  const { dynamic_content } = getLocalizedObject(props).page || {};

  // const pconCards = [
  //   {
  //     title: intl.formatMessage({ id: 'page/pcon/planner/title' }),
  //     image: article?.hero?.image,
  //     caption: getArticleCategory(article),
  //     link,
  //     slug: article?.slug,
  //   }
  // ]
  const cards = dynamic_content?.filter(
    (component) => component?.__typename === LayoutDynamicZoneComponentTypes.Card
  );

  const buttonGroups = (width, height) => [
    <div key={1} className={styles.buttonsRow}>
      <a
        href="https://pcon-planner.com/de/download/"
        target="_blank"
        rel="noreferrer"
        className={styles.button}>
        <Image
          src="/images/windows.jpg"
          alt="Windows"
          width={width}
          height={height}
          // className={styles.button}
        />
      </a>
    </div>,
    <div key={2}>
      <div className={styles.buttonsRow}>
        <a
          className={styles.button}
          href="https://play.google.com/store/apps/details?id=com.easterngraphics.ipi"
          target="_blank"
          rel="noreferrer">
          <Image
            src="/images/google-play.jpg"
            alt="Google Play"
            width={width}
            height={height}
            // className={styles.button}
          />
        </a>
        <a
          className={styles.button}
          href="https://itunes.apple.com/us/app/pcon.box/id1124979472?mt=8"
          target="_blank"
          rel="noreferrer">
          <Image
            src="/images/app-store.jpg"
            alt="App Store"
            width={width}
            height={height}
            // className={styles.button}
          />
        </a>
      </div>
      <a href="https://www.microsoft.com/store/apps/9nblggh536ct" target="_blank" rel="noreferrer">
        <Image src="/images/microsoft.jpg" alt="Microsoft" width={width} height={height} />
      </a>
    </div>,
    <div key={3} className={styles.buttonsRow}>
      <a
        className={styles.button}
        href="https://play.google.com/store/apps/details?id=com.easterngraphics.pfx"
        target="_blank"
        rel="noreferrer">
        <Image
          src="/images/google-play.jpg"
          alt="Google Play"
          width={width}
          height={height}
          // className={styles.button}
        />
      </a>
      <a
        className={styles.button}
        href="https://itunes.apple.com/us/app/pcon-facts/id1302104195?mt=8"
        target="_blank"
        rel="noreferrer">
        <Image
          src="/images/app-store.jpg"
          alt="App Store"
          width={width}
          height={height}
          // className={styles.button}
        />
      </a>
    </div>,
  ];

  return (
    <Media>
      {({ currentBreakpoint } = { currentBreakpoint: 'xs' }) => (
        <LayoutPage {...pageProperties}>
          {dynamic_content && (
            <LayoutDynamicZone
              exclude={LayoutDynamicZoneComponentTypes.Card}
              components={dynamic_content}
              groupCards={false}
            />
          )}

          {dynamic_content && (
            <Row {...rowInformativeGridProps}>
              {cards.map((component, idx) => {
                const data = {
                  id: component.id,
                  image: component.image,
                  slug: component.slug,
                  title: component.title,
                  description: component.body_text,
                };
                return (
                  <LayoutCard
                    key={idx}
                    data={data}
                    type={LayoutCardType.Overview}
                    dynamicRoute={false}
                    // {...restDynamicZoneProps}
                  >
                    {
                      (breakpoints[currentBreakpoint] < breakpoints.md
                        ? buttonGroups(121, 40)
                        : buttonGroups(150, 48))[idx]
                    }
                  </LayoutCard>
                );
              })}
              {/* <LayoutDynamicZone
              filter={LayoutDynamicZoneComponenTypes.Card}
              size={LayoutCardSize.Small}
              type={LayoutCardType.Overview}
              link="professionals"
              components={dynamic_content}
            /> */}
            </Row>
          )}
        </LayoutPage>
      )}
    </Media>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return {
    page: state.pages.pages[PageKeys.Pcon],
    ...state.pages,
  };
};

export default connect(mapStateToProps)(PagesPcon);
